
//import {counter} from './components/counter.js';
export let homeSections = () => {
    
    // For Home Page
    if($('body').hasClass('home')) {

        let mm = gsap.matchMedia();

        const headerButtonNav = $('.header__button-nav'),
		headerButtonNavControle = $('.header__button-nav-control'),
		headerLogo = $('.header__logo'),
		headerNav = $('.header__nav');

        function menuClose() {

            headerButtonNavControle.attr('aria-expanded', 'false');
			headerButtonNav.removeClass('header__button-nav--active');
			headerNav.removeClass('header__nav--active');
			headerLogo.removeClass('header__logo--active');
        }
       

        mm.add({
    
            isMobile: '(max-width: 720px)',
            isTablet: '(min-width:  720px) and (max-width: 1025px)',
            isDesktop: '(min-width: 1026px)'
    
        }, (context) => {
    
            let { isDesktop, isTablet, isMobile } = context.conditions;
    
            // desktop
    

            let section_number= 0,
                observer = ScrollTrigger.normalizeScroll(true),
                scrollTween,
                scrollActive = false,
                mobileScroll;

            // Section animations
            let intro_name = gsap.timeline({ paused: true })
                .to('.home__section__intro--name', { y: '0%', opacity: 1, duration:1, ease: 'power1.InOut', delay: 0.5 })
                .to('.home__section__intro--name', { opacity: 0, duration:1.5, ease: 'power1.InOut', delay: 2.5 });
            
                intro_name.play();
           
            // Section animations
            let intro_tl = gsap.timeline({ paused: true })
                .from('.home__section__intro', { y: '20%', opacity: 0, duration:1, ease: 'power1.InOut', delay: 0 })
                .from('.home__section__intro-header h1', { y: '20%', opacity: 0, duration:1, ease: 'power1.InOut', delay: 0 })
                .from(' .home__section__intro-header h4', { y: '20%', opacity: 0, duration:1, ease: 'power1.InOut', delay: 0 })
                .from('.home__section__intro-cities > p', { y: '20%', stagger: 0.5, opacity: 0, duration:1, ease: 'power1.InOut', delay: 0 });
           
            let introbg_tl = gsap.timeline({ paused: true })
                .to('#section-intro .section-background', { y: '50%', duration:1.1, ease: 'linear' });
            
           // let introOut_tl = gsap.timeline({ paused: true })
              // .to('#section-intro .home__section__intro', {opacity: 0, duration: 1, ease: 'linear'});

                                
            const firmStats = $('.home__section__firm-stats').children();
            //const firmStat = $('.home__section__firm-stat span');
            let firm_tl = gsap.timeline({ paused: true })
                .from('.home__section__firm__quote', { y: '20%', opacity: 0, duration:1.5, stagger: 1, ease: 'power1.InOut', delay: 0.5 })
                .from('.home__section__firm__quote-att', { y: '20%', opacity: 0, duration:1.5, stagger: 1, ease: 'power1.InOut', delay: 0 })
                .from(firmStats, { y: '20%', opacity: 0, duration:1, stagger: 0.5, ease: 'power1.InOut'}, '-=3')
                //.add( () => {counter(firmStat);}, 0);

                
            let statement = $('.home__section__statement-box').children();
            let statement_tl = gsap.timeline({ paused: true })
                 .from(statement, { y: '20%', opacity: 0, duration:1, stagger: 0.5, ease: 'power1.InOut', delay: 1 });
            
            let statementbgUp_tl = gsap.timeline({ paused: true })
                .to('#section-statement .section-background', { y: '50%', duration:1.1, ease: 'linear' });
            let statementbgDown_tl = gsap.timeline({ paused: true })
                .to('#section-statement .section-background', { y: '-50%', duration:1.1, ease: 'linear' });

            const newsVideos = $('.home__section__news-videos').children();
            const newsHeader = $('.home__section__news__header');
            const newsInner = $('.home__section__news__inner').children();
            let news_tl = gsap.timeline({ paused: true })
                .from([newsVideos, newsHeader, newsInner], { y: '20%', opacity: 0, duration:1, stagger: 0.5, ease: 'power1.InOut', delay: 1 });

            // For mobile interactions
            document.addEventListener("touchstart", e => {
                if (mobileScroll) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
            }, {capture: true, passive: false});

            // Scroll to Animation 
            function goToSection(i, s) {

                    scrollTween = gsap.to(window, {

                        overwrite: true,
                        duration: 1.5,
                        ...(isMobile ? console.log('mobile true') : { scrollTo: { y: i * innerHeight, autoKill: false } }),
                        onStart: () => {
                            //observer.disable(); // disable ScrollTrigger during the scroll
                            observer.enable();
                            isMobile ? '' : scrollActive = true;
                            menuClose();
                        },
                        onComplete: () => {
                            scrollTween = null;
                            isMobile ? '' : scrollActive = false
                        },
                        onToggle: () => {

                            const section_id = s.trigger.id;

                            if (section_id === "section-intro") {
                                intro_tl.play();
                                isMobile ? '' : firm_tl.reverse();

                                if(s.direction === -1){
                                    isMobile ? '' : introbg_tl.reverse();
                                }else{
                                    intro_tl.play().delay(4);
                                }

                            }
                            
                            if (section_id === "section-firm") {

                                isMobile ? '' : introbg_tl.play();
                                isMobile ? '' : intro_tl.reverse();
                                firm_tl.play();
                                
                                isMobile ? '' : statementbgDown_tl.play();
                                

                            }
                            
                            if (section_id === "section-statement") {

                                statement_tl.play();

                                if(s.direction === 1){
                                    isMobile ? '' : statementbgDown_tl.reverse();
                                }else{
                                    isMobile ? '' : statementbgUp_tl.reverse();
                                }

                            }
                            
                            if (section_id === "section-news") {
                                
                                news_tl.play();

                                isMobile ? '' : statementbgUp_tl.play();
                               
                            }
                        }
                    });
                
            }

            // ScrollTrigger for each section
            gsap.utils.toArray('.home__section').forEach((home_section, i) => {

                section_number++;
                scrollTween;
                ScrollTrigger.create({
                    
                    trigger: home_section,
                    start: isMobile ? "top 90%" :  "top 95%",
                    end: isMobile ? "bottom 90%" :  "bottom 5%",
                    toggleActions: "play reverse play reverse",
                    normalizeScroll: true,
                    //markers: true,
                    onToggle: (self) => {

                        if (self.isActive && scrollActive !== true)  {
                            
                            goToSection(i, self);

                        }
                    }
                });
         
                
                   
            });

            // ScrollTrigger Section Snapping functionality 
            if (isDesktop || isTablet) {

                ScrollTrigger.create({
                    start: 0, 
                    end: "max",   
                    snap:  isMobile ? '' : 1 / (section_number - 1)
                });

            }

        });

    } 

};